import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=2bcee0ce"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports